export const BASE_MODES = [
  "air",
  "road",
  "ocean",
  "rail"

  // , "multi"
];

export const ALL_MODES = [...BASE_MODES, "express", "parcel"];

export const MODES_ICONS = {
  road: "truck",
  ocean: "ship",
  rail: "train",
  air: "plane",
  multi: "exchange",
  express: "shipping fast",
  parcel: "box"
};
